import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f6f45a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column text-nowrap" }
const _hoisted_2 = {
  key: 0,
  class: "mx-2"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "break-all text-gray-400" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "mx-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "/", -1))
const _hoisted_8 = {
  key: 2,
  class: "badge badge-light-primary"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "break-all text-gray-400"
}
const _hoisted_14 = {
  key: 1,
  class: "break-all text-gray-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    placement: "top",
    width: "auto",
    trigger: "hover",
    disabled: 
      Number(_ctx.product_identifier_id) === 0 || _ctx.product_identifier_id === ''
    
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "width-limit",
          style: _normalizeStyle({ maxWidth: _ctx.maxWidth })
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.brand_article_no), 1),
          (_ctx.brand_article_no && _ctx.merchant_article_no)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "/"))
            : _createCommentVNode("", true),
          (_ctx.merchant_article_no)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.merchant_article_no), 1))
            : _createCommentVNode("", true)
        ], 4),
        _createElementVNode("div", {
          class: "fs-7 width-limit",
          style: _normalizeStyle({ maxWidth: _ctx.maxWidth })
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.normalColor)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("order.normalColor")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.normalColor), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.normalColor)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "/"))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("order.color")) + ": ", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.color ? _ctx.color : "--"), 1)
            ]),
            _hoisted_7,
            (_ctx.rangeSize)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("order.size")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.rangeSize), 1)
                ]))
              : (_ctx.size !== null)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 3,
                    class: _normalizeClass({
                'badge badge-light-primary': _ctx.size === 'default',
              })
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("order.size")) + ": ", 1),
                    (_ctx.size !== 'default' && _ctx.size !== '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.size), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "--"))
                  ], 2))
                : (_ctx.capacity !== null)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 4,
                      class: _normalizeClass({
                'badge badge-light-primary': _ctx.capacity === 'default',
              })
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("order.size")) + ": ", 1),
                      (_ctx.capacity !== 'default')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.capacity), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, "--"))
                    ], 2))
                  : _createCommentVNode("", true)
          ]),
          (_ctx.eanShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("order.ean")) + ": ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.ean ? _ctx.ean : "--"), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.countryShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("order.countryOfOrigin")) + ": ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.country ? _ctx.country : "--"), 1)
              ]))
            : _createCommentVNode("", true)
        ], 4)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, _toDisplayString(_ctx.product_identifier_id), 1)
    ]),
    _: 1
  }, 8, ["disabled"]))
}